module.exports = __webpack_public_path__ + "img/blackWhiteCat.b3044f36.png";